


























































import Vue from "vue";
import TarifCovidLayout from "@/@modules/tarif-covid/components/Layout.vue";
import { Auth } from "@/@core";
import { GraphqlService } from "@/@modules/tarif-covid/services";
import WorkerInfoHeader from "./WorkerInfoHeader.vue";
import RunRefSelector from "./RunRefSelector.vue";
import PaymentsDetailsList from "./PaymentsDetailsList.vue";
import PaymentsDetailsCounter from "./PaymentsDetailsCounter.vue";
import PaymentsDetailsDmgs from "./PaymentsDetailsDmgs.vue";
import PaymentsDetailsClaims from "./PaymentsDetailsClaims.vue";
import { Worker } from "@/@modules/tarif-covid/interfaces/Worker";
import { Period } from "@/@modules/tarif-covid/interfaces/Period";
import { RunRef } from "@/@modules/tarif-covid/interfaces/RunRef";
import {
  IndividualCareProvider,
  IndividualCareProviderByType,
  IndividualCareProviderType,
} from "@/@modules/tarif-covid/interfaces/IndividualCareProvider";
import { FinancialFlowState } from "@/@modules/tarif-covid/interfaces/FinancialFlow";
import { ClaimState } from "@/@modules/tarif-covid/interfaces/Claims";
export default Vue.extend({
  components: {
    TarifCovidLayout,
    WorkerInfoHeader,
    RunRefSelector,
    PaymentsDetailsList,
    PaymentsDetailsCounter,
    PaymentsDetailsDmgs,
    PaymentsDetailsClaims,
  },
  data() {
    return {
      loading: true,
      ssin: undefined as any,
      worker: {} as Worker,
      periods: [] as Period[],
      currentRunRef: {} as RunRef,
      individualCareProviders: [] as IndividualCareProviderByType[],
    };
  },
  async created() {
    try {
      await this.init();
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  computed: {
    isCitizen(): boolean {
      return Auth.isInRole(`CITIZEN`) && !Auth.isInRole(`SUPPORT`);
    },
  },
  methods: {
    async init() {
      this.loading = true;
      this.refreshSsin();
      await this.refreshWorker();
      await this.refreshPeriods();
      this.initCurrentRunRef();
      await this.initIndividualCareProviders();
      this.loading = false;
    },
    refreshSsin() {
      const ssin = !this.isCitizen ? this.$route.query.ssin : Auth.claims?.ssin;
      if (ssin) {
        this.ssin = ssin;
      } else {
        this.$router.push({ path: "/" });
        throw new Error(`No ssin provided`);
      }
    },
    async refreshWorker() {
      try {
        this.worker = Object.assign({}, this.worker, await GraphqlService.getWorker(this.ssin));
        if (this.isCitizen) {
          this.worker.claims = this.worker.claims?.filter(claim => {
            return claim.state != ClaimState.SUSPENTION;
          });
          this.worker.workerVCs?.forEach(workerVC => {
            workerVC.financialFlows =
              workerVC.financialFlows?.filter(financialFlow => {
                return financialFlow.state != FinancialFlowState.Rejected;
              }) || ([] as any);
          });
          this.worker.workerVCs?.filter(workerVC => {
            return (workerVC?.financialFlows?.length || 0) > 0;
          });
        }
        this.worker.workerVCs?.map(workerVC => {
          return workerVC.financialFlows?.map(financialFlow => {
            financialFlow.showDetails = !!(
              (financialFlow.communication || financialFlow.foreignBankAccount?.iban) &&
              !financialFlow.paymentNr?.endsWith("R") &&
              workerVC.exercise != "1912"
            );
            financialFlow.communication =
              financialFlow.communication || financialFlow.foreignBankAccount?.iban
                ? financialFlow.communication
                : "tarif-covid.payments-details.default-communication";
            return financialFlow;
          });
        });
      } catch {
        throw new Error(`The request failed for this ssin`);
      }
      if (!this.worker) {
        throw new Error(`No profile found for this ssin`);
      }
    },
    async refreshPeriods() {
      try {
        this.periods = Object.assign([], this.periods, this.filterPeriods(await GraphqlService.getPeriods()));
      } catch {
        throw new Error(`Cannot retrieve any period`);
      }
      if (!this.periods) {
        throw new Error(`Cannot retrieve any period`);
      }
    },
    filterPeriods(periods: Period[]) {
      return periods
        .map(period => {
          return Object.assign(period, {
            runs: period.runs?.filter(run => {
              return run.runInfos?.find(runType => {
                return runType.liquidations?.find(liquidation => {
                  return this.worker.workerVCs?.find(workerVC => {
                    return workerVC.financialFlows?.find(financialFlow => {
                      return financialFlow.liquidation?.id == liquidation.id;
                    });
                  });
                });
              });
            }),
          });
        })
        .filter(period => {
          return period?.runs?.length && period.runs.length > 0;
        });
    },
    initCurrentRunRef() {
      if (this.periods && this.periods.length > 0) {
        this.currentRunRef = Object.assign({}, this.currentRunRef, {
          of: {
            code: this.periods[0].code,
          },
          nr: this.periods[0].runs ? this.periods[0].runs[this.periods[0].runs.length - 1].nr : undefined,
        });
      }
    },
    async initIndividualCareProviders() {
      for (const period of this.periods) {
        const individualCareProviders = await GraphqlService.getIndividualCareProviders(
          this.ssin as string,
          period.code as string
        );
        if (this.individualCareProviders.length == 0) {
          this.individualCareProviders = Object.assign(
            [],
            this.individualCareProviders,
            individualCareProviders.map(individualCareProvider => {
              return {
                profession: individualCareProvider.profession,
                nihdi: individualCareProvider.nihdi,
                nihdiQualification: individualCareProvider.nihdiQualification,
                type: this.getIndividualCareProviderType(individualCareProvider),
              };
            })
          );
        }
        this.individualCareProviders.map(individualCareProvider => {
          const icp = individualCareProviders.find(icp => {
            return icp.nihdi == individualCareProvider.nihdi;
          });
          if (icp) {
            icp.encounters?.forEach(encounter => {
              if (!individualCareProvider.encounters) {
                individualCareProvider.encounters = {};
              }
              if (!individualCareProvider.encounters[period.code as string]) {
                individualCareProvider.encounters[period.code as string] = {};
              }
              if (!individualCareProvider.encounters[period.code as string][encounter.run as number]) {
                individualCareProvider.encounters[period.code as string][encounter.run as number] = [];
              }
              individualCareProvider.encounters[period.code as string][encounter.run as number].push(encounter);
            });
            icp.forfait?.forEach(forfait => {
              if (!individualCareProvider.forfaits) {
                individualCareProvider.forfaits = {};
              }
              if (!individualCareProvider.forfaits[period.code as string]) {
                individualCareProvider.forfaits[period.code as string] = {};
              }
              if (!individualCareProvider.forfaits[period.code as string][forfait.run as number]) {
                individualCareProvider.forfaits[period.code as string][forfait.run as number] = [];
              }
              individualCareProvider.forfaits[period.code as string][forfait.run as number].push(forfait);
            });
          }
        });
      }
    },
    getIndividualCareProviderType(individualCareProvider: IndividualCareProvider) {
      if (
        individualCareProvider.profession == "MIDWIFE" ||
        individualCareProvider.profession == "KINE" ||
        individualCareProvider.profession == "LOGO" ||
        individualCareProvider.profession == "PSYCHOLOGIST" ||
        individualCareProvider.profession == "REMEDIAL_TEACHER" ||
        individualCareProvider.profession == "NURSE" ||
        individualCareProvider.profession == "NURSING_AUXILIARY" ||
        (individualCareProvider.profession == "DOCTOR" &&
          individualCareProvider.nihdiQualification != "052" &&
          individualCareProvider.nihdiQualification != "152" &&
          individualCareProvider.nihdiQualification != "222" &&
          individualCareProvider.nihdiQualification != "422" &&
          individualCareProvider.nihdiQualification != "520" &&
          individualCareProvider.nihdiQualification != "521" &&
          individualCareProvider.nihdiQualification != "041" &&
          individualCareProvider.nihdiQualification != "378" &&
          individualCareProvider.nihdiQualification != "410" &&
          individualCareProvider.nihdiQualification != "414" &&
          individualCareProvider.nihdiQualification != "423")
      ) {
        return IndividualCareProviderType.ENCOUNTER2_5;
      } else if (
        individualCareProvider.profession == "DENTIST" ||
        (individualCareProvider.profession == "DOCTOR" && individualCareProvider.nihdiQualification == "052") ||
        individualCareProvider.nihdiQualification == "152" ||
        individualCareProvider.nihdiQualification == "222" ||
        individualCareProvider.nihdiQualification == "422" ||
        individualCareProvider.nihdiQualification == "520" ||
        individualCareProvider.nihdiQualification == "521" ||
        individualCareProvider.nihdiQualification == "041" ||
        individualCareProvider.nihdiQualification == "378" ||
        individualCareProvider.nihdiQualification == "410" ||
        individualCareProvider.nihdiQualification == "414" ||
        individualCareProvider.nihdiQualification == "423"
      ) {
        return IndividualCareProviderType.ENCOUNTER20;
      } else if (
        individualCareProvider.profession == "DIETICIAN" ||
        individualCareProvider.profession == "PODIATRIST" ||
        individualCareProvider.profession == "ORTHOPTIST" ||
        individualCareProvider.profession == "ERGOTHERAPIST"
      ) {
        return IndividualCareProviderType.FORFAIT;
      }
    },
  },
});
